import React from "react";
import Grid from "@material-ui/core/Grid";

import "./.Basics.css";

export default function Title({
  titulo,
  icon: Icon,
  buttons = [],
  classNameDiv = "root-title",
  classNameDivAlign = "title-grid-align",
  classNameH3 = "title-title inline",
}) {
  return (
    <div className={classNameDiv}>
      <Grid container spacing={2}>
        <Grid item xs={9} sm={6} lg={6}>
          <div className={classNameDivAlign}>
            {Icon && <Icon id="title-icon" />}
            <h3 className={classNameH3}>{titulo}</h3>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} lg={6}>
          {buttons}
        </Grid>
      </Grid>
    </div>
  );
}
